export type VimeoOEmbedResponse = {
  title: string;
  thumbnail_url: string;
  duration: number;
  author_name: string;
  video_id: number;
};

export const getVimeoOEmbed = async ({
  vimeoId,
  signal,
  isFullUrl = false,
}: {
  vimeoId: string;
  signal?: AbortSignal;
  isFullUrl?: boolean;
}): Promise<VimeoOEmbedResponse> => {
  const videoUrl = isFullUrl ? vimeoId : `https://vimeo.com/${vimeoId}`;
  const response = await fetch(`https://vimeo.com/api/oembed.json?url=${videoUrl}`, { signal });

  if (!response.ok) {
    throw new Error(`Failed to fetch Vimeo data: ${response.statusText}`);
  }

  return response.json();
};
